// frontend/src/components/MlPredict/MlPredict.tsx

import React from 'react';
import { useMlModels } from '../../hooks/useMlModels';
import { MlPredictSelector } from './MlPredictSelector';
import { MlPredictForm } from './MlPredictForm';
import { MlPredictResult } from './MlPredictResult';
import './MlPredict.css';

export const MlPredict: React.FC = () => {
  const {
    models,
    selectedAlias,
    schema,
    prediction,
    loadingModels,
    loadingSchema,
    predicting,
    error,
    selectModel,
    runPrediction,
  } = useMlModels();

  if (error && models.length === 0) {
    return (
      <div className="predict-container">
        <div className="error-state">❌ {error}</div>
      </div>
    );
  }

  return (
    <div className="predict-container">
      <div className="predict-header">
        <h1>🎯 Predições</h1>
        <p className="subtitle">
          Use um modelo em produção para fazer predições em tempo real
        </p>
      </div>

      <MlPredictSelector
        models={models}
        selectedAlias={selectedAlias}
        onSelect={selectModel}
        loading={loadingModels}
      />

      {loadingSchema && (
        <div className="loading-state">📊 Carregando schema do modelo...</div>
      )}

      {schema && !loadingSchema && (
        <>
          <MlPredictForm
            schema={schema}
            predicting={predicting}
            onSubmit={runPrediction}
          />

          {prediction && (
            <MlPredictResult
              prediction={prediction}
              schema={schema}
            />
          )}
        </>
      )}

      {error && models.length > 0 && (
        <div className="error-state">❌ {error}</div>
      )}
    </div>
  );
};

export default MlPredict;